import React, { FC } from 'react'
import { Title } from '@shared/ui/Typography/Title'
import s from '@widgets/Common/Footer/Footer.module.sass'

export const FooterTitle: FC = () => (
  <Title sizes='h3 h4 h4' tag='h4' className={s.title}>
    Приложение Афиши&nbsp;&mdash; самый удобный способ забронировать стол
  </Title>
)
